import {
  DetailedHTMLProps,
  HTMLAttributes,
  LabelHTMLAttributes,
  PropsWithChildren,
} from 'react';
import { VariantProps } from 'tailwind-variants';
import { typographyStyles } from './styles';

type ITextVariants = 'p' | 'span' | 'label' | 'b' | 'small';

export interface ITextProps
  extends HTMLAttributes<
      HTMLParagraphElement &
        HTMLSpanElement &
        DetailedHTMLProps<
          LabelHTMLAttributes<HTMLLabelElement>,
          HTMLLabelElement
        > &
        HTMLElement
    >,
    VariantProps<typeof typographyStyles> {
  variant?: ITextVariants;
}

export function Text({
  align = 'left',
  bold,
  children,
  className,
  italic,
  textTransform,
  underline,
  variant: TextTag = 'p',
  ...rest
}: PropsWithChildren<ITextProps>): JSX.Element {
  return (
    <TextTag
      className={typographyStyles({
        align,
        className,
        textTransform,
        bold,
        italic,
        underline,
      })}
      {...rest}
    >
      {children}
    </TextTag>
  );
}
